import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import { selectSeriesInfoForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import SameSeries from './SameSeries';

export class SameSeriesContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleBibTitle({ bib, source }) {
    const bibId = bib.get('metadataId');
    const metadata = {
      metadata_category_type: 'bibliographic_details_title',
      metadata_value: bib.get('title'),
      metadata_enrichment_provider: source
    };
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'in-the-same-series',
      ui_component_type: 'link-text',
      ui_component_label: bib.get('title')
    };

    this.props.trackContentClick({ bibId, metadata, ui });
  }

  handleBibImage({ bib, source }) {
    const bibId = bib.get('metadataId');
    const metadata = {
      metadata_category_type: 'bibliographic_details_title',
      metadata_value: bib.get('title'),
      metadata_enrichment_provider: source
    };
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'in-the-same-series',
      ui_component_type: 'link-image'
    };

    this.props.trackContentClick({ bibId, metadata, ui });
  }

  render() {
    return <SameSeries {...this.props} handleBibTitle={this.handleBibTitle} handleBibImage={this.handleBibImage} />;
  }
}

SameSeriesContainer.propTypes = {
  open: PropTypes.bool,
  series: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape,
  trackContentClick: PropTypes.func
};

const mapStateToProps = state => {
  return {
    catalogBib: selectCatalogBib(state),
    series: selectSeriesInfoForCurrentBib(state)
  };
};

const mapDispatchToProps = {
  trackContentClick
};

export default connect(mapStateToProps, mapDispatchToProps)(SameSeriesContainer);
